import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/40'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-xl md:text-2xl font-bold font-heading text-primary-500">
              韩影深解
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? 'text-primary-500'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/crime-thriller"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              电影分类
            </Link>
            <Link
              to="/article/bong-joon-ho-narrative-evolution"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/article')
                  ? 'text-primary-500'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              深度解析
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about')
                  ? 'text-primary-500'
                  : 'text-foreground-600 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-300/40">
          <div className="flex flex-col px-4 py-4 gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'text-primary-500' : 'text-foreground-600'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/crime-thriller"
              className={`text-sm font-medium py-2 transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-600'
              }`}
            >
              电影分类
            </Link>
            <Link
              to="/article/bong-joon-ho-narrative-evolution"
              className={`text-sm font-medium py-2 transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/article') ? 'text-primary-500' : 'text-foreground-600'
              }`}
            >
              深度解析
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium py-2 transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about') ? 'text-primary-500' : 'text-foreground-600'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}